// extracted by mini-css-extract-plugin
module.exports = {"filterLabel":"RecordsFilter_filterLabel_i0B9a","filtersWrap":"RecordsFilter_filtersWrap_25IpV"};